const TOKEN_KEY = 'openvoter_token'
const AUTH_CHANGE_EVENT = 'openvoter-auth-change'

export type AuthChangeReason = 'set' | 'clear'

export interface AuthChangeDetail {
  reason: AuthChangeReason
  token: string | null
}

function notifyAuthChange(detail: AuthChangeDetail): void {
  window.dispatchEvent(new CustomEvent<AuthChangeDetail>(AUTH_CHANGE_EVENT, { detail }))
}

export function onAuthChange(listener: (detail: AuthChangeDetail) => void): () => void {
  const handle = (event: Event) => listener((event as CustomEvent<AuthChangeDetail>).detail)
  window.addEventListener(AUTH_CHANGE_EVENT, handle)
  return () => window.removeEventListener(AUTH_CHANGE_EVENT, handle)
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token)
  notifyAuthChange({ reason: 'set', token })
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY)
  notifyAuthChange({ reason: 'clear', token: null })
}

export function isAuthenticated(): boolean {
  return !!getToken()
}
